/**
 * Tax-summary advice card formatting knocks.
 * Masked amount hides liability until the user is Elite; advance-tax math
 * mirrors backend thresholds so the card matches the tax plan sheet.
 */
export const TAX_SUMMARY_MASKED_AMOUNT = '₹****'
export const TAX_SUMMARY_ADVANCE_TAX_LIABILITY_THRESHOLD = 10000
export const TAX_SUMMARY_ADVANCE_TAX_RATE = 0.15
export const TAX_SUMMARY_MONTH_SHORT_NAMES = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec'
] as const
